module.exports = __webpack_public_path__ + "static/media/ifs_02.f03bbdf6.jpg";